
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-20672.75 -24497.75 14.775 15.459"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_231_1","data-name":"Symbol 231 – 1","transform":"translate(-21073 -24585)","opacity":".54"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"line","d":"M0 0l3.651 3.753","transform":"translate(410.314 97.894)"}}),_c('ellipse',{staticClass:"cls-2",attrs:{"id":"ellipse","cx":"5.561","cy":"5.493","rx":"5.561","ry":"5.493","transform":"translate(401 88)"}})])])
          )
        }
      }
    